import { useState } from "react";
import { useTranslation } from "react-i18next";
import { usStates, mexicanStates } from "../../../../Helper/CountryStates";
import { TrashIcon } from "../../../../Media/Icons";
import instance from "../../../../Interceptor/api_instance";
import { Spinner } from "../../../../Components/LoadingAnimations/LoadingAnimations";
import { ActionConfirm, ActionResponse } from "../../../../Components/Modals/ActionResponses";

export const EditBacklogRow = ({ row, close, entity_type }) => {
  const { t } = useTranslation();
  const [city, state, country] = row.truck.origin.split(", ");
  const destination = row.truck?.destination?.split(", ") ?? [];
  const [dcity, dstate, dcountry] = destination;

  const [requestLoading, setRequestLoading] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);

  const trailer = row.trailer
    ? {
        trailer_number: row.trailer ? row.trailer.trailer_number : null,
        customer: row.trailer ? row.trailer.customer : null,
        is_loaded: row.trailer ? row.trailer.is_loaded : null,
        trailer_plate: row.trailer ? row.trailer.license_plate : null,
        seal_number: row.trailer ? row.trailer.seal_number : null,
        check_out_seal_number: row.trailer
          ? row.trailer.check_out_seal_number
          : null,
      }
    : null;
  const [newRow, setNewRow] = useState({
    ...trailer,
    id: row.id,
    truckNum: row.truck.truckNum,
    driverName: row.visitor.driverName,
    truck_plate: row.truck.truck_plate,
    city: city,
    state: state,
    country: country,
    dcity: dcity,
    dstate: dstate,
    dcountry: dcountry,
  });

  const deleteEvent = async () => {
    try {
      setRequestLoading(true);
      const response = await instance.patch(`assets/reactivate?id=${row.id}`);
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      setRequestLoading(true);
      var response = null;
      if (entity_type === "trailer") {
        response = await instance.patch("assets/edit-backlog-trailer", newRow);
      } else {
        response = await instance.patch("assets/edit-backlog-truck", newRow);
      }
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };
  const handleInputChange = (key, value) => {
    setNewRow((prevRow) => ({
      ...prevRow,
      [key]: value,
    }));
  };

  return (
    <>
      {deletePrompt && (
        <ActionConfirm
          title={t("graphics-cont.confirm-modal.delete-event")}
          message={t("graphics-cont.confirm-modal.confirm-delete")}
          warning={t("warnings.delete_check_out")}
          confirm={() => deleteEvent()}
          close={() => setDeletePrompt(false)}
          requestLoading={requestLoading}
        />
      )}
      <div className="page-mask page-mask-animation">
        <div className="edit-modal">
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h4 data-testid="backlog-row" className="global-h2">
                {t("forms.type.edit-entry")}
              </h4>
              {row.check_out_dt &&
                new Date() - new Date(row.check_out_dt) <
                  24 * 60 * 60 * 1000 && (
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "lightgray",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <div onClick={() => setDeletePrompt(true)}>
                      <TrashIcon />
                    </div>
                  </div>
                )}
            </div>
            <p className="gray">
              {entity_type === "trailer"
                ? row.trailer.trailer_number
                : row.truck.truckName}
            </p>
          </div>
          <form onSubmit={submit}>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.truck")}
              </label>
              <div className="input-cont">
                <label className="input-label">{row.truck.truckName}</label>
              </div>
            </div>
            {row.trailer && (
              <div className="form-group">
                <label className="input-label">
                  {t("yard-tables.table-columns.trailer")}
                </label>
                <div className="input-cont">
                  <label className="input-label">
                    {row.trailer.trailer_number}
                  </label>
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="input-label" htmlFor="driver">
                {t("yard-tables.table-columns.driver")}
              </label>
              <div className="input-cont">
                <label className="input-label">{row.visitor.driverName}</label>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label" htmlFor="truck-plates">
                {t("yard-tables.table-columns.truck")}{" "}
                {t("yard-tables.table-columns.license_plate")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input"
                  name="truck-plates"
                  id="truck-plates"
                  value={newRow.truck_plate}
                  onClick={(e) =>
                    handleInputChange("truck_plate", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label" htmlFor="destination">
                {t("yard-tables.search-filters.dropdowns.destination")}
              </label>
              <div className="input-cont">
                <select
                  value={newRow.dcountry}
                  onChange={(e) =>
                    handleInputChange("dcountry", e.target.value)
                  }
                >
                  <option value="USA">
                    {t("forms.type.vehicle.placeholders.usa")}
                  </option>
                  <option value="Mexico">Mexico</option>
                </select>
                <select
                  value={newRow.state}
                  onChange={(e) => handleInputChange("dstate", e.target.value)}
                >
                  {newRow.dcountry === "USA"
                    ? usStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))
                    : mexicanStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label"></label>
              <div className="input-cont">
                <input
                  id="city"
                  type="text"
                  name="city"
                  className="text-input"
                  value={newRow.dcity}
                  placeholder={t(
                    "forms.type.vehicle.placeholders.destination.City"
                  )}
                  onChange={(e) => handleInputChange("dcity", e.target.value)}
                  required
                />
              </div>
            </div>
            {row.trailer ? (
              <>
                <div className="form-group">
                  <label className="input-label">
                    {t("yard-tables.table-columns.customer")}
                  </label>
                  <div className="input-cont">
                    <input
                      type="text"
                      className="text-input"
                      value={newRow.customer}
                      onChange={(e) =>
                        handleInputChange("customer", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="input-label">
                    {t("yard-tables.table-columns.content")}
                  </label>
                  <div className="input-cont">
                    <select
                      value={newRow.is_loaded}
                      onChange={(e) =>
                        handleInputChange("is_loaded", e.target.value)
                      }
                    >
                      <option value={true}>
                        {t("forms.type.vehicle.placeholders.loaded")}
                      </option>
                      <option value={false}>
                        {t("forms.type.vehicle.placeholders.empty")}
                      </option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label className="input-label">
                    {t("yard-tables.table-columns.seal")}
                  </label>
                  <div className="input-cont">
                    <input
                      type="text"
                      className="text-input"
                      value={newRow.seal_number}
                      onChange={(e) =>
                        handleInputChange("seal_number", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="input-label">
                    {t("buttons.check-out")}{" "}
                    {t("yard-tables.table-columns.seal")}
                  </label>
                  <div className="input-cont">
                    <input
                      type="text"
                      className="text-input"
                      value={newRow.check_out_seal_number}
                      onChange={(e) =>
                        handleInputChange(
                          "check_out_seal_number",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="input-label">
                    {t("yard-tables.table-columns.trailer")}{" "}
                    {t("yard-tables.table-columns.license_plate")}
                  </label>
                  <div className="input-cont">
                    <input
                      type="text"
                      onChange={(e) =>
                        handleInputChange("trailer_plate", e.target.value)
                      }
                      className="text-input"
                      value={newRow.trailer_plate}
                    />
                  </div>
                </div>
              </>
            ) : null}
            <div className="btn-cont">
              {requestLoading ? (
                <Spinner />
              ) : (
                <>
                  <button type="submit" className="other-btn">
                    {t("buttons.update")}
                  </button>
                  <button onClick={close} className="close-btn">
                    {t("buttons.close")}
                  </button>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      {message && (
        <ActionResponse
          message={message}
          status={status}
          close={
            status === t("forms.type.success")
              ? () => window.location.reload()
              : () => {
                  setMessage(null);
                  setStatus(null);
                }
          }
        />
      )}
    </>
  );
};

export const EditBacklogTruck = ({ row, close }) => {
  const { t } = useTranslation();
  const destination = row.truck?.destination?.split(", ") ?? [];
  const [dcity, dstate, dcountry] = destination;
  console.log(row.truck.destination);
  const [requestLoading, setRequestLoading] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);

  const [newRow, setNewRow] = useState({
    id: row.id,
    truckNum: row.truck.truckNum,
    driverName: row.visitor.driverName,
    truck_plate: row.truck.truck_plate,
    dcity: dcity,
    dstate: dstate,
    dcountry: dcountry,
  });
  console.log(newRow.dstate);

  const deleteEvent = async () => {
    try {
      setRequestLoading(true);
      const response = await instance.patch(`assets/reactivate?id=${row.id}`);
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      setRequestLoading(true);
      const response = await instance.patch(
        "assets/edit-backlog-truck",
        newRow
      );
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };
  const handleInputChange = (key, value) => {
    setNewRow((prevRow) => ({
      ...prevRow,
      [key]: value,
    }));
  };

  return (
    <>
      {deletePrompt && (
        <ActionConfirm
          title={t("graphics-cont.confirm-modal.delete-event")}
          message={t("graphics-cont.confirm-modal.confirm-delete")}
          warning={t("warnings.delete_check_out")}
          confirm={() => deleteEvent()}
          close={() => setDeletePrompt(false)}
          requestLoading={requestLoading}
        />
      )}
      <div className="page-mask page-mask-animation">
        <div className="edit-modal">
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h4 data-testid="backlog-row" className="global-h2">
                {t("forms.type.edit-entry")}
              </h4>
              {row.check_out_dt &&
                new Date() - new Date(row.check_out_dt) <
                  24 * 60 * 60 * 1000 && (
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "lightgray",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <div onClick={() => setDeletePrompt(true)}>
                      <TrashIcon />
                    </div>
                  </div>
                )}
            </div>
          </div>
          <form onSubmit={submit}>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.truck")}
              </label>
              <div className="input-cont">
                <label className="input-label">{row.truck.truckName}</label>
              </div>
            </div>
            {row.trailer && (
              <div className="form-group">
                <label className="input-label">
                  {t("yard-tables.table-columns.trailer")}
                </label>
                <div className="input-cont">
                  <label className="input-label">
                    {row.trailer.trailer_number}
                  </label>
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="input-label" htmlFor="driver">
                {t("yard-tables.table-columns.driver")}
              </label>
              <div className="input-cont">
                <label className="input-label">{row.visitor.driverName}</label>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label" htmlFor="truck-plates">
                {t("yard-tables.table-columns.truck")}{" "}
                {t("yard-tables.table-columns.license_plate")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input"
                  name="truck-plates"
                  id="truck-plates"
                  value={newRow.truck_plate}
                  onClick={(e) =>
                    handleInputChange("truck_plate", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label" htmlFor="destination">
                {t("yard-tables.search-filters.dropdowns.destination")}
              </label>
              <div className="input-cont">
                <select
                  value={newRow.dcountry}
                  onChange={(e) =>
                    handleInputChange("dcountry", e.target.value)
                  }
                >
                  <option value="USA">
                    {t("forms.type.vehicle.placeholders.usa")}
                  </option>
                  <option value="Mexico">Mexico</option>
                </select>
                <select
                  value={newRow.dstate}
                  onChange={(e) => handleInputChange("dstate", e.target.value)}
                >
                  {newRow.dcountry === "USA"
                    ? usStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))
                    : mexicanStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label"></label>
              <div className="input-cont">
                <input
                  id="city"
                  type="text"
                  name="city"
                  className="text-input"
                  value={newRow.dcity}
                  placeholder={t(
                    "forms.type.vehicle.placeholders.destination.City"
                  )}
                  onChange={(e) => handleInputChange("dcity", e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="btn-cont">
              {requestLoading ? (
                <Spinner />
              ) : (
                <>
                  <button type="submit" className="other-btn">
                    {t("buttons.update")}
                  </button>
                  <button onClick={close} className="close-btn">
                    {t("buttons.close")}
                  </button>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      {message && (
        <ActionResponse
          message={message}
          status={status}
          close={
            status === t("forms.type.success")
              ? () => window.location.reload()
              : () => {
                  setMessage(null);
                  setStatus(null);
                }
          }
        />
      )}
    </>
  );
};

export const EditBacklogTrailer = ({ row, close }) => {
  const { t } = useTranslation();

  const destination = row.trailer.destination ? row.trailer.destination.split(", ") : [null, null, null];
  const [dcity, dstate, dcountry] = destination;
  const [editableData, setEditableData] = useState({
    id: row.trailer.id,
    is_loaded: row.trailer.is_trailer_loaded,
    customer: row.trailer.customer,
    seal_number: row.trailer.sealNumber,
    check_out_seal_number: row.trailer.check_out_seal_number,
    license_plate: row.trailer.license_plate,
    dcity: dcity,
    dstate: dstate,
    dcountry: dcountry || "USA",
  });

  const [requestLoading, setRequestLoading] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);

  const deleteEvent = async () => {
    try {
      setRequestLoading(true);
      const response = await instance.patch(`assets/reactivate?id=${row.id}`);
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };
  const handleInputChange = (key, value) => {
    setEditableData((prevRow) => ({
      ...prevRow,
      [key]: value,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      setRequestLoading(true);
      const response = await instance.patch(
        "assets/edit-backlog-trailer",
        editableData
      );
      if (response.status === 200) {
        setStatus(t("forms.type.success"));
        setMessage(t("forms.type.responses.success"));
      }
    } catch (error) {
      console.log(error);
      setStatus("Error");
      setMessage(error);
    } finally {
      setRequestLoading(false);
    }
  };
  return (
    <>
      {deletePrompt && (
        <ActionConfirm
          title={t("graphics-cont.confirm-modal.delete-event")}
          message={t("graphics-cont.confirm-modal.confirm-delete")}
          warning={t("warnings.delete_check_out")}
          confirm={() => deleteEvent()}
          close={() => setDeletePrompt(false)}
          requestLoading={requestLoading}
        />
      )}
      <div className="page-mask page-mask-animation">
        <div className="edit-modal">
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h4 data-testid="backlog-row" className="global-h2">
                {t("forms.type.edit-entry")}
              </h4>
              {row.check_out_dt &&
                new Date() - new Date(row.check_out_dt) <
                  24 * 60 * 60 * 1000 && (
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "lightgray",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <div onClick={() => setDeletePrompt(true)}>
                      <TrashIcon />
                    </div>
                  </div>
                )}
            </div>
          </div>
          <form onSubmit={submit}>
            {/* Header */}
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.trailer")}
              </label>
              <div className="input-cont">
                <label className="input-label">
                  {row.trailer.trailer_number}
                </label>
              </div>
            </div>

            <div className="form-group">
              <label className="input-label" htmlFor="destination">
                {t("yard-tables.search-filters.dropdowns.destination")}
              </label>
              <div className="input-cont">
                <select
                  value={editableData.dcountry}
                  onChange={(e) =>
                    handleInputChange("dcountry", e.target.value)
                  }
                >
                  <option value="USA">
                    {t("forms.type.vehicle.placeholders.usa")}
                  </option>
                  <option value="Mexico">Mexico</option>
                </select>
                <select
                  value={editableData.dstate}
                  onChange={(e) => handleInputChange("dstate", e.target.value)}
                >
                  {editableData.dcountry === "USA"
                    ? usStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))
                    : mexicanStates.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label"></label>
              <div className="input-cont">
                <input
                  id="city"
                  type="text"
                  name="city"
                  className="text-input"
                  value={editableData.dcity}
                  placeholder={t(
                    "forms.type.vehicle.placeholders.destination.City"
                  )}
                  onChange={(e) => handleInputChange("dcity", e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.customer")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input"
                  value={editableData.customer}
                  onChange={(e) =>
                    handleInputChange("customer", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.content")}
              </label>
              <div className="input-cont">
                <select
                  value={editableData.is_loaded}
                  onChange={(e) =>
                    handleInputChange("is_loaded", e.target.value)
                  }
                >
                  <option value={true}>
                    {t("forms.type.vehicle.placeholders.loaded")}
                  </option>
                  <option value={false}>
                    {t("forms.type.vehicle.placeholders.empty")}
                  </option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.seal")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input"
                  value={editableData.seal_number}
                  onChange={(e) =>
                    handleInputChange("seal_number", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label">
                {t("buttons.check-out")} {t("yard-tables.table-columns.seal")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  className="text-input"
                  value={editableData.check_out_seal_number}
                  onChange={(e) =>
                    handleInputChange("check_out_seal_number", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="input-label">
                {t("yard-tables.table-columns.trailer")}{" "}
                {t("yard-tables.table-columns.license_plate")}
              </label>
              <div className="input-cont">
                <input
                  type="text"
                  onChange={(e) =>
                    handleInputChange("license_plate", e.target.value)
                  }
                  className="text-input"
                  value={editableData.license_plate}
                />
              </div>
            </div>

            <div className="btn-cont">
              {requestLoading ? (
                <Spinner />
              ) : (
                <>
                  <button type="submit" className="other-btn">
                    {t("buttons.update")}
                  </button>
                  <button onClick={close} className="close-btn">
                    {t("buttons.close")}
                  </button>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      {message && (
        <ActionResponse
          message={message}
          status={status}
          close={
            status === t("forms.type.success")
              ? () => window.location.reload()
              : () => {
                  setMessage(null);
                  setStatus(null);
                }
          }
        />
      )}
    </>
  );
};
